import ManualRedirect from './ManualRedirect'
export default ManualRedirect
